import React, { createContext, useCallback, useEffect, useState, useRef } from 'react'

export const LayoutContext = createContext()

const LayoutProvider = ({ location, children }) => {
  const [siteTheme, setSiteTheme] = useState('')
  const [showSplash, setShowSplash] = useState(true)
  const scrollSmoother = useRef(null)

  const setTheme = useCallback((name) => {
    setSiteTheme(name)
  }, [])

  useEffect(() => {
    if (showSplash && location && location.pathname !== '/') {
      setShowSplash(false)
    }
  }, [location, showSplash])

  return (
    <LayoutContext.Provider
      value={{
        siteTheme,
        setTheme,
        showSplash,
        setShowSplash,
        scrollSmoother
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export default LayoutProvider
